// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"376":"5f995bb3be98ab06","858":"242a2ad2ece620c9"}[chunkId] + ".css";
};